import { render, staticRenderFns } from "./AdmissionsList.vue?vue&type=template&id=7b70d7eb&scoped=true&"
import script from "./AdmissionsList.vue?vue&type=script&lang=js&"
export * from "./AdmissionsList.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionsList.vue?vue&type=style&index=0&id=7b70d7eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b70d7eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VChip,VDataTable,VDivider,VPagination,VSpacer,VToolbar})
